var querystring = require('querystring');
var toPairs = require('lodash/toPairs');

var qp = {
  toString: function (params) {
    var str = '';
    toPairs(params)
      .sort()
      .map(function(param) {
          if (param[1] !== undefined) {
              if (str !== '') str += '&';
              str += param[0] + '=' + encodeURIComponent(param[1]);
          }
      });
    return str;
  },

  toObject: function (str) {
    return querystring.parse(str);
  }
};

//
module.exports = qp;



//////////////////
// WEBPACK FOOTER
// ./~/query-parse/index.js
// module id = 61
// module chunks = 28313394369846 114276838955818 211641130022272